import React, { startTransition, useEffect, useState } from 'react';
import { Button, Space, Typography, message } from 'antd';
import TableWrap from '../../../../components/TableWrap';
import './index.scss';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../store';
import { deleteQuestionSet, getAllQuestionSet } from '../../../../store/questions/questionSlice';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import ModalDelete from '../../../../components/Modal/ModalDelete';

const { Text } = Typography;

const SurveyManagement: React.FC = () => {
  const questionSlice = useSelector((state: RootState) => state.question);
  const { data, loading } = questionSlice;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      dispatch(getAllQuestionSet());
    } catch (error) {
      console.log(`${error}`);
    }
  }, [dispatch]);

  const columns = [
    {
      title: '日間',
      key: 'type',
      dataIndex: 'type',
      render: (type: number) => <Text className="bold-text">{type}</Text>,
    },
    {
      title: 'バウチャーコード',
      dataIndex: 'voucherName',
      key: 'voucherName',
      render: (voucherName: string) => <Text className="text-cell">{voucherName}</Text>,
    },
    {
      title: '状態',
      key: 'status',
      render: (_: any, record: any) =>
        record.isActive ? <Text className="active-text">有効</Text> : <Text type="danger">無効化</Text>,
    },
    {
      title: '',
      key: 'action',
      align: 'center' as const,
      render: (_: any, record: any) => (
        <Space size="middle">
          <Button
            type="link"
            icon={
              <img src={`${process.env.PUBLIC_URL}/assets/icons/edit.png`} alt="Edit Logo" className="icon-table" />
            }
            onClick={() => handleEdit(record)}
          />
          <Button
            type="link"
            icon={
              <img src={`${process.env.PUBLIC_URL}/assets/icons/delete.png`} alt="Delete Logo" className="icon-table" />
            }
            danger
            onClick={() => showDeleteModal(record)}
          />
        </Space>
      ),
    },
  ];

  const handleEdit = (record: any) => {
    startTransition(() => {
      navigate(`/survey-management/${record.qsId}`);
    });
  };

  const showDeleteModal = (record: any) => {
    setSelectedRecord(record);
    setIsModalOpen(true);
  };

  const handleDelete = async () => {
    try {
      const result = await dispatch(deleteQuestionSet(selectedRecord.qsId));
      if (result.meta.requestStatus === 'fulfilled') {
        message.success('削除が成功しました!');
        dispatch(getAllQuestionSet());
      } else {
        message.error('削除に失敗しました。もう一度お試しください。');
      }
    } catch (error) {
      message.error('削除中にエラーが発生しました。');
    } finally {
      setIsModalOpen(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleReset = () => {
    startTransition(() => {
      navigate(`/survey-management/create`);
    });
  };

  return (
    <div className="survey-management-container">
      <div className="survey-management-header">
        <Button type="primary" onClick={handleReset}>
          新作成
        </Button>
      </div>
      <TableWrap
        columns={columns}
        data={_.sortBy(data, 'type').slice((currentPage - 1) * pageSize, currentPage * pageSize)}
        isLoading={loading}
        total={data.length}
        page={currentPage}
        size={pageSize}
        setPage={(page) => setCurrentPage(page)}
        setSize={(newPageSize) => {
          setPageSize(newPageSize);
          setCurrentPage(1);
        }}
      />
      <ModalDelete
        isOpen={isModalOpen}
        onOk={handleDelete}
        onCancel={handleCancel}
        content="「質問セット」を削除してもよろしいですか？"
      />
    </div>
  );
};

export default SurveyManagement;
